export default "__VITE_ASSET__2768a18f__"